import script from "./property-peek-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./property-peek-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__